import React, { ChangeEvent } from 'react';
import {
  Input,
  ErrorInput,
  FullWidthInput,
  InputDiv,
  InputDivWide,
  ErrorMessage,
  Asterisk,
} from './EditMicrosoftDataForm.styles';

interface StandardInputProps {
  label: string;
  name: string;
  value: string;
  placeholder: string;
  error?: boolean;
  isValid?: boolean; // Context validation
  errorMessage?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  inputRef: (el: HTMLInputElement | null) => void;
  required?: boolean;
}

export const StandardInput = ({
  label,
  name,
  value,
  placeholder,
  error,
  isValid,
  errorMessage,
  onChange,
  inputRef,
  required = true,
}: StandardInputProps) => {
  const hasError = error || (isValid === false);
  return (
    <InputDiv>
      <label htmlFor={name}>
        {label} {required && <Asterisk>*</Asterisk>}
      </label>
      {hasError ? (
        <ErrorInput
          ref={inputRef}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      ) : (
        <Input
          ref={inputRef}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      )}
      {hasError && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputDiv>
  );
};

interface WideInputProps extends StandardInputProps {
  useErrorInput?: boolean;
}

export const WideInput = ({
  label,
  name,
  value,
  placeholder,
  error,
  isValid,
  errorMessage,
  onChange,
  inputRef,
  useErrorInput = false,
  required = true,
}: WideInputProps) => {
  const hasError = error || (isValid === false);
  
  return (
    <InputDivWide>
      <label htmlFor={name}>
        {label} {required && <Asterisk>*</Asterisk>}
      </label>
      {useErrorInput && hasError ? (
         <ErrorInput
         ref={inputRef}
         name={name}
         placeholder={placeholder}
         value={value}
         onChange={onChange}
       />
      ) : (
        <FullWidthInput
            name={name}
            ref={inputRef}
            placeholder={placeholder}
            value={value}
            // @ts-ignore - style prop or error prop handling differs
            style={!useErrorInput && hasError ? { border: '1px solid red' } : undefined}
            error={!useErrorInput ? hasError : undefined}
            onChange={onChange}
        />
      )}
      {hasError && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputDivWide>
  );
};

